import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { useEffect } from 'react';
import { trackBannerInteraction } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PromotionBanner = ({
  promotion,
  title,
  description,
  cta,
  dataSelenium,
  shouldShow = true
}) => {
  useEffect(() => {
    if (shouldShow) {
      const name = `${promotion.toLowerCase()} promotion banner`;
      trackBannerInteraction({
        action: 'view',
        name
      });
    }
  }, [shouldShow, promotion]);
  if (!shouldShow) return null;
  return /*#__PURE__*/_jsx(Alert, {
    "data-selenium": dataSelenium,
    type: "info",
    titleText: title,
    inlineSize: "100%",
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [description, cta && /*#__PURE__*/_jsx(View, {
        as: "span",
        children: /*#__PURE__*/_jsx(Button, {
          href: cta.url,
          use: "tertiary",
          size: "extra-small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: cta.message
          })
        })
      })]
    })
  });
};
export default PromotionBanner;